/* eslint-disable no-process-env */
const parse = require('semver/functions/parse');

/**
 * Composes the package name and version in a repeatable manner.
 *
 * @param {String|Boolean} [name] - The package name. If `false`, the name will be omitted.
 * @param {String} [version] - The package version.
 * @returns {String} - The package name and version concatenated for use in source code.
 * @throws {Error} - If the version is not a string.
 * @private
 */
module.exports = function identifier(name, version) {
  const explicitNoName = typeof name === 'boolean' && !name;
  const explicitName = typeof name === 'string' && name;

  if (!explicitNoName && !explicitName && process.env.npm_package_name) {
    name = process.env.npm_package_name;
  }

  if (!version && process.env.npm_package_version) {
    version = process.env.npm_package_version;
  }

  if (typeof version !== 'string') {
    throw new Error(`@ux/data-version: given version is invalid: ${version}`);
  }

  const { major } = parse(version);
  return [name, major].filter(Boolean).join('@');
};
